import React from 'react';
import {Input, Modal, Radio,TreeSelect} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {getInfoFromLocalStorage} from "../../../actions";
import {transferSpecialCharacter} from "../../../utils";
import {getMaxWidth} from "../../statisticalAnalysis/statisticsTable/utils";
import TableTemplate from "../../newMediaMatrix/components/TableTemplate/TableTemplate";
import BaseComponent from "../../../base/BaseComponent";
import PaginationTemplate from "../../newMediaMatrix/components/PaginationTemplate/PaginationTemplate";
import {message} from "../../../utils/message";

/**
 * creat by xcc
 * @description 选择被转交人
 */

const {Search} = Input;
export default class TransferPersonSelect extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            dataSource: [],
            visible: false,
            page: 1,
            size: 10,
            count: 0,
            searchValue: "",
            selectedRow: null,
            viewSearchValue: ""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getDeptData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;    //防止内存泄露
        };
    }

    getData(callback) {
        let body = {
            start: this.state.page,
            size: this.state.size,
            permissionCodes: ["pms:positionManage:addBtn"],
        };
        if (this.state.searchValue) {
            body.accountOrName = transferSpecialCharacter(this.state.searchValue);
        }
        if(this.state.deptId){
            body.belongDeptIds = [this.state.deptId]
        }
        this.request({
            url: "/cm-sites-sys/user/getUserByPermissionsGroupByDept/v2",
            body: body,
            method: "post",
            contentType: "json",
            callBack: (data) => {
                let dataSource = [];
                let count = 0;
                if (data && data.data && data.data.length) {
                    dataSource = data.data;
                    count = data.count;
                }
                this.setState({
                    dataSource,
                    count
                }, () => {
                    callback && callback()
                })
            },
            errorCallBack: () => {

            },
            serverVerify: {
                serverErrorCallBack: () => {

                }
            }
        });
    }

    openModal = (callback) => {
        this.getData(callback);
        this.setState({
            visible: true
        })
    }

    setData = (transferPerson) => {
        if (transferPerson) {
            const uniqueKey = `${transferPerson._id}-${transferPerson.deptList?.[0]?.id || ""}`;
            this.setState({ selectedRow: uniqueKey });
        }
    }

    handleChecked(record) {
        let deptId = record.deptList?.[0]?.id || "";
        const uniqueKey = `${record._id}-${deptId}`;
        // 设置当前点击的行作为选中状态，同时清除其他行的选中状态
        this.setState({ selectedRow: uniqueKey });
    }

    getColumns() {
        return ([
            {
                title: "",
                key: 'checked',
                width: 50,
                render: (record => {
                    let deptId = record.deptList?.[0]?.id || "";
                    const uniqueKey = `${record._id}-${deptId}`;
                    const isSelected = this.state.selectedRow === uniqueKey;
                    return (
                        <div>
                            <Radio checked={isSelected} onChange={() => {
                                this.handleChecked(record);
                            }}/>
                        </div>
                    )
                })
            },
            {
                title: '姓名',
                key: 'name',
                dataIndex: 'name',
                ellipsis: true,
                width: 200
            },
            {
                title: '账号',
                key: 'account',
                dataIndex: 'account',
                ellipsis: true,
                width: 200
            },
            {
                title: '部门',
                key: 'deptIds',
                ellipsis: true,
                render: (record) => {
                    const deptNames = record.deptList && Array.isArray(record.deptList)
                        ? record.deptList.map(item => item.name)
                        : [];
                    const namesString = deptNames.length > 0 ? deptNames.join("，") : '-';
                    return (
                        <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                            {namesString}
                        </div>
                    );
                }
            }
        ])
    }

    onCancel = () => {
        this.setState({visible: false});
        if (typeof this.props.onCancel === 'function') {
            this.props.onCancel()
        }
    };

    okSubmit = () => {
        let {dataSource} = this.state;
        const selectedRecord = dataSource.find(item => this.state.selectedRow === `${item._id}-${item.deptList?.[0]?.id || ""}`);
        if (!selectedRecord) {
            message.warn("请选择被转交人");
            return false;
        }
        this.onOkCall(selectedRecord);
    }

    // 确认
    onOkCall = (selectedRecord) => {
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall(selectedRecord, () => {
                this.setState({visible: false});
            })
        }
    };

    /**
     * 当页码变换的回调
     * @param page
     * @param pageSize
     */
    onPageChange = ({current, pageSize}) => {
        this.setState({
            page: current,
            size: pageSize
        }, () => {
            this.getData();
        });
    };

    /**
     * pageSize 变化的回调
     * @param current
     * @param size
     */
    onShowSizeChange = ({current, pageSize}) => {
        this.setState({
            page: 1,
            size: pageSize
        }, () => {
            this.getData();
        });
    };

    onChangeDept = (value,deptName) => {
        this.setState(
          {
            deptId: value,
            deptName,
            page:1
          },
          () => {
            this.getData()
          }
        );
      };

      handleSearch = (val) => {
        this.setState({
          viewSearchValue: val,
        });
      };

      handleBlur = () => {
        setTimeout(() => {
          this.setState({
            viewSearchValue: "",
          });
        }, 100);
      };

      getDeptData = () => {
        this.request({
          url: "/cm-sites-sys/dept/getTree",
          body: { id:0 },
          callBack: (res) => {
            let tree = [];
            if (res.id) {
              tree = [res];
            }
            this.format(tree);
            let newTree = this.checkData(tree);
            this.setState({ treeData: newTree });
          },
        });
      };

      format = (tree) => {
        let formatConfig = {
          title: "name",
          key: "id",
          value: "id",
          children: "child",
        };
        if (tree?.length && formatConfig) {
          tree.forEach((item) => {
            for (let i in formatConfig) {
              item[i] = item[formatConfig[i]];
            }
            if (item?.children?.length) {
              this.format(item?.children);
            }
          });
        }
      };

      checkData = (tree, call) => {
        let newTreeData = [];
        if (tree?.length) {
          newTreeData = tree;
          tree.forEach((item) => {
            if (item.id == "0") {
              newTreeData = item.children;
            }
          });
        }
        return newTreeData;
      };

    render() {
        const columns = this.getColumns();
        let {dataSource, visible, tabKey = "transferPersonSelect", count, page, size,viewSearchValue,treeData} = this.state;
        let {title} = this.props;
        return (
            <Modal
                title={title}
                maskClosable={false}
                visible={visible}
                onCancel={this.onCancel}
                onOk={this.okSubmit}
                width={900}
                centered={true}
                className={"selectModal"}
            >
                <>
                    <div style={{marginBottom: 10}}>
                        <Search
                            allowClear={true}
                            placeholder="搜索姓名/账号"
                            onSearch={(searchValue) => {
                                this.state.page = 1;
                                this.setState({
                                    searchValue
                                }, () => {
                                    this.getData()
                                })
                            }}
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e.target.value,
                                });
                            }}
                            style={{width: 200}}
                        />
                        <TreeSelect
                            showSearch
                            style={{ width:150,marginLeft:10}}
                            dropdownStyle={{
                            maxHeight: 400,
                            overflow: "auto",
                            maxWidth: 250,
                            }}
                            dropdownClassName={"tree-select-custom-class-name"}
                            placeholder={"请选择部门"}
                            allowClear
                            treeDefaultExpandAll
                            onChange={(v,label) => {
                            this.onChangeDept(v,label[0])
                            }}
                            onSearch={this.handleSearch}
                            searchValue={viewSearchValue}
                            onBlur={this.handleBlur}
                            treeData={treeData}
                            filterTreeNode={(input, treeNode) => {
                            return treeNode.props.title.includes(input);
                            }}
                        />

                    </div>
                    <Scrollbars autoHide autoHeight autoHeightMax={400}>
                        <TableTemplate
                            key={"TableTemplate" + tabKey}
                            maxWidth={getMaxWidth(this.pageMargin * 2 + this.pagePadding * 2)}
                            maxHeight={this.tableHeight}
                            columns={columns}
                            dataSource={dataSource}
                            onResize={(offsetHeight) => {
                                if (this.tableHeight != offsetHeight) {
                                    this.tableHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                        />
                    </Scrollbars>
                    {this.state.count > 10 ?
                        <PaginationTemplate
                            key={"PageTemplate" + tabKey}
                            total={count || 0}
                            pageSize={size || 10}
                            current={page || 1}
                            config={{size:"m"}}
                            dataSource={dataSource}
                            onShowSizeChange={this.onShowSizeChange}
                            onChange={this.onPageChange}
                            onResize={(offsetHeight) => {
                                if (this.paginationHeight != offsetHeight) {
                                    this.paginationHeight = offsetHeight;
                                    this.setState({});
                                }
                            }}
                            showHeight={false}
                        /> : null}
                </>
                <style>
                    {`.selectModal .ant-modal-body{padding: 14px 32px 0px 32px}`}
                </style>
            </Modal>
        )
    }
}